import Section from "@/components/Section";
import BreadcrumbsNav from "@/components/UI-Kit/BreadcrumbsNav";
import { Container, Typography, useTheme } from "@mui/material";
import GeneralSection from "./components/GeneralSection";
import ProductSection from "./components/ProductSection";
// import PopularArticlesSection from "./components/PopularArticlesSection";
// import PopularVideosSection from "./components/PopularVideosSection";
import ContactUsSection from "./components/ContactUsSection";

const HelpCenter = () => {
  const theme = useTheme();
  return (
    <>
      <Container sx={{ pt: { xs: 3, lg: 0 }, pb: { xs: 4, lg: 0 } }}>
        <BreadcrumbsNav />
      </Container>
      <Section pt={{ xs: 0, md: 4, lg: 13.75 }} pb={{ xs: 6.25, md: 8.75 }}>
        <Typography
          sx={{
            color: theme.palette.grey[800],
            marginBottom: "16px",
          }}
          variant="h1"
        >
          <Typography
            component="span"
            variant="h1"
            sx={{
              color: theme.palette.primary.main,
            }}
          >
            Trackmate Support Center
          </Typography>
        </Typography>
        <Typography
          variant="subtitle1"
          component="p"
          sx={{
            color: theme.palette.grey[600],
          }}
        >
          We’re here to ensure you have all the information you need for a seamless Trackmate experience.
        </Typography>
      </Section>
      <GeneralSection />
      <ProductSection />
      {/* <PopularArticlesSection />
      <PopularVideosSection /> */}
      <ContactUsSection />
    </>
  );
};

export default HelpCenter;
